import Axios from '../baseApi';

export default {
  addOrUpdate(form) {
    return Axios.post(`/api-registration/v1/registration-capacity`, form);
  },
  fetchById(slaughterHouseId) {
    return Axios.get(`/api-registration/v1/registration-capacity/${slaughterHouseId}`);
  },
  free(form) {
    return Axios.post(`/api-registration/v1/free-capacity`, form);
  }
}
